
import { Component } from 'vue-property-decorator';
import ProfileForm from '@/components/profile/ProfileForm.vue';
import { ProfileFormData, ProfileResponse } from '@/model/Profile';
import { mapActions, mapGetters } from 'vuex';
import { mixins } from 'vue-class-component';
import ToastMixin from '@/mixins/ToastMixin';
import ToastVariant from '@/model/enums/toast/toast-variant';
import PasswordForm from '@/components/profile/PasswordForm.vue';

@Component({
    components: {
        ProfileForm,
        PasswordForm,
    },
    methods: {
        ...mapActions({
            fetchProfile: 'profileStorage/fetchProfile',
            updateProfile: 'profileStorage/updateProfile',
            updatePassword: 'profileStorage/updatePassword',
        }),
    },
    computed: {
        ...mapGetters({
            getProfile: 'profileStorage/getProfile',
            passwordError: 'profileStorage/getErrorPassword',
            profileError: 'profileStorage/getErrorProfile',
        }),
    },
})
export default class Profile extends mixins(ToastMixin) {
    fetchProfile!: () => Promise<void | ProfileResponse>;

    updateProfile!: (formData: ProfileFormData) => Promise<void>;

    updatePassword!: (formData: ProfileFormData) => Promise<void>;

    getProfile!: ProfileResponse | null;

    loading = true;

    mounted(): void {
        this.$store.commit('profileStorage/setErrorProfile', null);
        this.$store.commit('profileStorage/setErrorPassword', null);
        this.fetchProfile().finally(() => {
            this.loading = false;
        });
    }

    onSubmitProfile(formData: ProfileFormData): void {
        this.loading = true;
        this.updateProfile(formData)
            .then(() => {
                this.showToast(
                    this.$t('profile.notification.successful').toString(),
                    this.$t('profile.notification.title').toString(),
                    ToastVariant.SUCCESS,
                );
            })
            .finally(() => {
                this.loading = false;
            });
    }

    onSubmitPassword(formData: ProfileFormData): void {
        this.loading = true;
        this.updatePassword(formData)
            .then(() => {
                this.$router.push({ name: 'Login' });
                this.showToast(
                    this.$t('password.notification.successful').toString(),
                    this.$t('password.notification.title').toString(),
                    ToastVariant.SUCCESS,
                );
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
